import { AuthService } from '../services/AuthService';
import {
  type ICommentLinksRequest,
  type ICommentLinksResponse,
  type ICommentListResponse,
  type ICommentResponse,
  type ICreateCommentData
} from '@/types/IComment';
import { CustomError, type IGenericResponseRoot } from '../utils/getErrorData';
import { api } from '../utils/api';

export const createManagerOrderComment = async (
  data: ICreateCommentData
): Promise<ICommentResponse> => {
  try {
    const formData = new FormData();
    formData.append('order', data.order);

    if (data.text !== null && data.text !== undefined) {
      formData.append('text', data.text);
    }

    if (
      data.images !== null &&
      data.images !== undefined &&
      data.images.length > 0
    ) {
      data.images.forEach((img) => {
        formData.append('images[]', img);
      });
    }

    if (
      data.files !== null &&
      data.files !== undefined &&
      data.files.length > 0
    ) {
      data.files.forEach((file) => {
        formData.append('files[]', file);
      });
    }

    const headers: Record<string, string> = {};
    if (AuthService.authToken !== null) {
      headers.Authorization = `Bearer ${AuthService.authToken}`;
    } else {
      throw new Error('Пользователь не авторизирован');
    }

    const response = await api.post<IGenericResponseRoot<ICommentResponse>>(
      `${import.meta.env.VITE_API_URL}/api/admin/manager-order-comment`,
      formData,
      { headers }
    );

    if (response.status === 500) {
      throw new CustomError(
        'Произошла необработанная ошибка при создании комментария'
      );
    }

    if (response.data.response === null) {
      throw new CustomError('При создании комментария произошла ошибка');
    }

    return response.data.response;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    throw error;
  }
};

export const getManagerOrderComments = async (
  orderUuid: string,
  params?: { limit?: number; offset?: number }
): Promise<ICommentListResponse> => {
  try {
    const headers: Record<string, string> = {};
    if (AuthService.authToken !== null) {
      headers.Authorization = `Bearer ${AuthService.authToken}`;
    } else {
      throw new Error('Пользователь не авторизирован');
    }

    const response = await api.get<IGenericResponseRoot<ICommentListResponse>>(
      `${import.meta.env.VITE_API_URL}/api/admin/manager-order-comments/${orderUuid}`,
      {
        headers,
        params
      }
    );

    if (response.status === 500) {
      throw new CustomError(
        'Произошла необработанная ошибка при получении комментариев'
      );
    }

    if (response.data.response === null) {
      throw new CustomError('При получении комментариев произошла ошибка');
    }

    return response.data.response;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    throw error;
  }
};

export const getManagerOrderCommentLinks = async (
  commentUuid: string,
  data: ICommentLinksRequest
): Promise<ICommentLinksResponse> => {
  try {
    const headers: Record<string, string> = {};
    if (AuthService.authToken !== null) {
      headers.Authorization = `Bearer ${AuthService.authToken}`;
    } else {
      throw new Error('Пользователь не авторизирован');
    }

    const response = await api.post<
      IGenericResponseRoot<ICommentLinksResponse>
    >(
      `${import.meta.env.VITE_API_URL}/api/admin/manager-order-comment/${commentUuid}/links`,
      data,
      { headers }
    );

    if (response.status === 500) {
      throw new CustomError(
        'Произошла необработанная ошибка при получении ссылок'
      );
    }

    if (response.data.response === null) {
      throw new CustomError('При получении ссылок произошла ошибка');
    }

    return response.data.response;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    throw error;
  }
};
